import * as React from 'react';

import { PencilSVG, SkipLogicSVG } from '@components/svgs';
import { Tooltip } from '@components/Tooltip';

import { RuleSummary } from './RuleSummary/RuleSummary';
import { SkipLogicSummary } from './SkipLogicSummary';

interface EditSkipLogicIconButtonProps {
  hasScreenerQualificationRules: boolean;
  question: ScreenerField;
  questions: ScreenerField[];
  autoReview: boolean;
  hasAnIdealAnswer: boolean;
  editable: boolean;
  onOpenScreenerRulesSlideout: () => void;
  onOpenSkipLogic: () => void;
}

export const EditSkipLogicIconButton: React.FC<EditSkipLogicIconButtonProps> = ({
  hasScreenerQualificationRules,
  question,
  questions,
  editable,
  onOpenScreenerRulesSlideout,
  onOpenSkipLogic,
  hasAnIdealAnswer,
  autoReview
}) => {
  const shouldRender =
    (!hasScreenerQualificationRules && question.skip_logic && question.skip_logic.length > 0) ||
    (hasScreenerQualificationRules &&
      question.answer_tag_logic?.some(
        (obj) =>
          obj.tag_type === 'skip_to' ||
          obj.tag_type === 'ideal' ||
          obj.tag_type === 'disqualifying' ||
          obj.tag_type === 'ignore_disqualified'
      ));

  if (!shouldRender) return null;

  return (
    <div className='border-b border-gray-200 p-1'>
      {hasScreenerQualificationRules ? (
        <div className='p-2'>
          <div className='flex items-center'>
            <div className='flex items-center p-2'>
              <SkipLogicSVG />
              <span className='ml-2 text-xs text-gray-700'>Logic and answer tagging</span>
            </div>

            {editable && (
              <div className='ml-auto'>
                <Tooltip maxWidth={240} content={'Edit logic and answer tagging'}>
                  <button
                    type='button'
                    className='flex h-10 w-10 items-center justify-center rounded-full text-gray-500 hover:bg-gray-100'
                    onClick={onOpenScreenerRulesSlideout}
                  >
                    <PencilSVG />
                  </button>
                </Tooltip>
              </div>
            )}
          </div>
          <RuleSummary question={question} questions={questions} />
        </div>
      ) : (
        <div className='flex justify-between'>
          <div className='flex items-center space-x-2 p-3 text-gray-700'>
            <SkipLogicSummary
              question={question}
              questions={questions}
              autoReview={autoReview}
              hasAnIdealAnswer={hasAnIdealAnswer}
            />
          </div>
          {editable && (
            <div className='pr-2'>
              <Tooltip maxWidth={240} content={'Edit skip logic'}>
                <button
                  type='button'
                  className='flex h-10 w-10 items-center justify-center rounded-full text-gray-500 hover:bg-gray-100'
                  onClick={onOpenSkipLogic}
                >
                  <PencilSVG />
                </button>
              </Tooltip>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
